export default __webpack_public_path__ + "static/media/image 13.d803eab4.svg";